const { DateTime } = require('luxon');

/**
 * Validates a value is a dates
 * @param {any} value The value to validate.
 * @param {any} context Validation context
 * @param {string} context.format A string defining the format of the date.
 * @return {Promise<string | null>} A promise that resolves to an error message, otherwise null
 * @name date
 * @memberof combinators
 */
async function validate(value, context) {
  // always pass on a null input
  if (value === undefined || value === null) {
    return Promise.resolve(null);
  }

  const format = context.format || 'dd/MM/yyyy';
  return Promise.resolve(DateTime.fromFormat(value, format).isValid ? null : 'not-date');
}

module.exports = validate;